import {removeAccessAdministrationUserPermissionOverride} from "@project/sdk/access-administration";
import {RemoveAccessAdministrationUserPermissionOverrideResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {accessAdministrationMutationKeys, userAccessKeys} from "../../access-administration-keys";

export function removePermissionOverrideMutationOptions(userId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.removePermissionOverride,
    mutationFn: async (permissionKey: string) =>
      RemoveAccessAdministrationUserPermissionOverrideResponse.parse(
        await removeAccessAdministrationUserPermissionOverride(userId, permissionKey),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: userAccessKeys.detail(userId)});
    },
  });
}
